<template>
  <router-link :to="url">
    <div
      class="flex flex-row text-lg lg:text-xl font-semibold mt-6 hover:text-darkpurple"
    >
<!--      <div class="text-right">-->
<!--        <span>{{ startTime.hours }}</span>-->
<!--        <span v-if="startTime.minute !== '00'">:{{ startTime.minute }}</span>-->
<!--        <span class="uppercase">{{ startTime.ampm }}</span>-->
<!--        <span class="text-sm"> ({{timeZone}})</span>-->
<!--      </div>-->
<!--      <div class="mx-2">-</div>-->
      <div class="w-2/3">
        <div class="uppercase font-bold text-xl lg:text-2xl">
          {{ session.title }}
        </div>
        <div>
          <!--        {{session.title}}-->
        </div>
        <div>
          with {{ session.speakers[0].name }}
          <span class="relative inline-flex h-3 w-3 ml-2" v-if="live">
            <span
              class="animate-ping absolute inline-flex h-full w-full rounded-full bg-peach opacity-75"
            ></span>
            <span
              class="relative inline-flex rounded-full h-3 w-3 bg-peach"
            ></span>
          </span>
          <span
            v-if="live"
            class="ml-2 text-peach font-semibold tracking-wider uppercase"
            >Live</span
          >
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
  import {getTimeZoneString, toFriendlyTimeAMPMObj} from "../utils/dateHelpers";

export default {
  name: "PaperAgendaItem",
  props: {
    session: {
      type: Object,
      require: true
    }
  },
  computed: {
    url() {
      return `/session/${this.session.slug.current}`;
    },

    startTime() {
      return toFriendlyTimeAMPMObj(this.session.startTime)
    },
    timeZone() {
      return getTimeZoneString();
    },
    live() {
      return this.session.watchStatus === "LIVE";
    }
  }
};
</script>

<style scoped></style>
